module.exports = __webpack_public_path__ + "static/media/IMG_4291.8236378a.PNG";